import { createReducer } from "@reduxjs/toolkit"
import {
    setActiveWebsiteData,
    setTableModal,
    setPageStatus,
    setModalStatus,
    setFullScreenStatus,
    setMapViewStatus,
} from "../actions"
import { setResponse, setMapWaypointResponse } from "./actions"
import { setHistoryLoading } from "../templateData/actions"

const initialState = {
    website: {
        name: "",
        logo: "",
        url: "",
        type: "",
    },
    table: {
        status: false,
    },
    general_apis: {},
    page_loading_status: false,
    modalStatus: false,
    fullScreen: false,
    view_mode: "map_view",
    history_loading: false,
}

const GeneralReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setResponse, (state, action) => {
            state.general_apis[action.payload.key] = action.payload.data
        })
        .addCase(setMapWaypointResponse, (state, action) => {
            state.general_apis[action.payload.key] = action.payload.data
        })
        .addCase(setTableModal, (state, action) => {
            state.table.status = action.payload
        })
        .addCase(setPageStatus, (state, action) => {
            state.page_loading_status = action.payload
        })
        .addCase(setHistoryLoading, (state, action) => {
            state.history_loading = action.payload
        })
        .addCase(setModalStatus, (state, action) => {
            state.modalStatus = action.payload
        })
        .addCase(setFullScreenStatus, (state, action) => {
            state.fullScreen = action.payload
        })
        .addCase(setMapViewStatus, (state, action) => {
            state.view_mode = action.payload
        })
        .addCase(setActiveWebsiteData, (state, action) => {
            state.website = action.payload.website
        })
        .addDefaultCase((state, action) => state)
})

export default GeneralReducer
